import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { LocalStorageClass } from '../helpers/local-storage-helper';
import { ToastService } from '../services/shared/toast.service';

export function errorInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
  router: Router,
  toast: ToastService
): Observable<HttpEvent<unknown>> {
  // v2 auth endpoints are anonymous and legitimately return 401/403/400 during
  // the login flow (invalid credentials, "already logged in", transient token
  // validation on approval/status). The auth screens handle these themselves —
  // skip the global redirect/reload so the user isn't bounced mid-login.
  const isV2AuthRequest = request.url.includes('/v2/auth/');

  return next(request).pipe(
    catchError((error) => {
      if (error.status === 401 && !isV2AuthRequest) {
        LocalStorageClass.clearUserData();
        router.navigate(['login']);
      }

      if (error.status === 403 && !isV2AuthRequest) {
        window.location.reload();
      }

      const errorCode = error?.error?.errors?.[0]?.code;

      if (errorCode) toast.error(`errors.${errorCode}`);

      return throwError(() => error);
    })
  );
}
